module.exports = __webpack_public_path__ + "static/media/apple-touch-icon.b43e7014.png";